import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimetableBlockFactorForm } from '../Forms/TimetableBlockFactorForm';

type TimetableBlockFactorModalProps = {
  timetableBlockUuid: string;
  isOpen: boolean;
  onClose: () => void;
};

export const TimetableBlockFactorModal = ({ timetableBlockUuid, isOpen, onClose }: TimetableBlockFactorModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal width='s' title={t('timetableBlock.editBlock')} loading={loading} isOpen={isOpen} onRequestClose={onClose}>
      <Suspense fallback={<LazyLoader embedded forceHeight='218px' />}>
        <TimetableBlockFactorForm timetableBlockUuid={timetableBlockUuid} onLoad={setLoading} onClose={onClose} />
      </Suspense>
    </Modal>
  );
};
